import type React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import MikiwameLoader from './MikiwameLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/** 読み込み中の見た目を落ち着いて確認するための逃げ道。
 *  データ取得が速いと一瞬で消えてしまい、デザインの確認ができないため。
 *  ローカルと dev のホストでだけ効く（本番では無視される）。 */
const PREVIEW_HOSTS = ['localhost', '127.0.0.1', 'factcheck-ai-develop.web.app'];
const isLoaderPreview = () =>
  PREVIEW_HOSTS.includes(window.location.hostname) &&
  new URLSearchParams(window.location.search).has('loader');

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 認証チェック中。この裏で既にマイアイテムの取得が走っている（services/prefetch.ts）
  if (loading || isLoaderPreview()) {
    return <MikiwameLoader brand fullHeight size={200} label="見極める準備をしています" />;
  }

  // 未認証の場合はログイン画面にリダイレクト
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 認証済みの場合は子コンポーネントを表示
  return <>{children}</>;
};

export default ProtectedRoute;
